import VueI18n from 'vue-i18n'
import Vue from 'vue'
import de from './translations/de.json';
import en from './translations/en.json';

Vue.use(VueI18n)

const messages = {
  en,
  de
};

const locale = window.location.hostname.startsWith('en.') ? 'en' : 'de';

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale, // set locale
  messages, // set locale messages
})

